import { render } from "./Trading-button.vue?vue&type=template&id=3d7c67a8&scoped=true"
import script from "./Trading-button.vue?vue&type=script&lang=js"
export * from "./Trading-button.vue?vue&type=script&lang=js"

import "./Trading-button.vue?vue&type=style&index=0&id=3d7c67a8&lang=scss&scoped=true"

import exportComponent from "/tmp/build_0358080b/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d7c67a8"]])

export default __exports__